import { themeWorkspace } from "../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "feedback",
    name: "%{BKY_CATFEEDBACK}",
    colour: themeWorkspace.categoryStyles.feedback_category.colour,
    imageName: "/toolbox-imgs/random-solid.svg",
    id: "4",
    contents: [
      {
        kind: "block",
        type: "feedback_message_type",
      },
      {
        kind: "block",
        type: "random_message",
        fields: {
          message: "defaultMessageSolutionFoundAtFirstAttempt",
        },
      },
      {
        kind: "block",
        type: "is_solution_found",
        fields: {
          solution_found_type: "isSolutionQuestionFound",
        },
      },
      {
        kind: "block",
        type: "current_attempt",
      },
      {
        kind: "block",
        type: "max_attempts",
      },
      {
        kind: "block",
        type: "feedback_global",
      },
      {
        kind: "block",
        type: "feedback_global",
        inputs: {
          feedbacks: {
            block: {
              type: "controls_if",
              inputs: {
                IF0: {
                  block: {
                    type: "logic_negate",
                    inputs: {
                      BOOL: {
                        block: {
                          type: "is_solution_found",
                          fields: {
                            solution_found_type: "areAllSolutionsActivityFound",
                          },
                        },
                      },
                    },
                  },
                },
                DO0: {
                  block: {
                    type: "display_element",
                    inputs: {
                      object: {
                        block: {
                          type: "richtext_create_with",
                          extraState: { itemsCount: 2 },
                          inputs: {
                            ADD0: {
                              block: {
                                type: "random_message",
                                fields: {
                                  message: "defaultMessageSolutionNotFound",
                                },
                              },
                            },
                            ADD1: {
                              block: {
                                type: "question_open",
                                extraState: {
                                  displaymoreOptions: true,
                                  statement: false,
                                },
                                fields: {
                                  type: "integer",
                                  moreOptions: true,
                                  mutation_shape: "value",
                                  answer: {
                                    name: "answer",
                                    type: "",
                                  },
                                  default_feedbacks: true,
                                  raw_options: "{}",
                                },
                                inputs: {
                                  text: {
                                    shadow: {
                                      type: "text",
                                      fields: {
                                        TEXT: "question",
                                      },
                                    },
                                  },
                                  solution: {
                                    shadow: {
                                      type: "math_number",
                                      fields: {
                                        NUM: 1,
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "controls_if",
        extraState: {
          hasElse: true,
        },
        inputs: {
          IF0: {
            block: {
              type: "is_solution_found",
              fields: {
                solution_found_type: "isSolutionQuestionFound",
              },
            },
          },
          DO0: {
            block: {
              type: "display_element",
              inputs: {
                object: {
                  block: {
                    type: "random_message",
                    fields: {
                      message: "defaultMessageSolutionFound",
                    },
                  },
                },
              },
            },
          },
          ELSE: {
            block: {
              type: "controls_if",
              extraState: {
                hasElse: true,
              },
              inputs: {
                IF0: {
                  block: {
                    type: "logic_compare",
                    fields: {
                      OP: "LT",
                    },
                    inputs: {
                      A: {
                        block: {
                          type: "current_attempt",
                        },
                      },
                      B: {
                        block: {
                          type: "max_attempts",
                        },
                      },
                    },
                  },
                },
                DO0: {
                  block: {
                    type: "display_element",
                    inputs: {
                      object: {
                        block: {
                          type: "random_message",
                          fields: {
                            message:
                              "defaultMessageSolutionNotFoundButRemainingAttempts",
                          },
                        },
                      },
                    },
                  },
                },
                ELSE: {
                  block: {
                    type: "display_element",
                    inputs: {
                      object: {
                        block: {
                          type: "random_message",
                          fields: {
                            message: "defaultMessageSolutionNotFound",
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_EXPERT}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "procedures_defnoreturn",
        fields: { NAME: "Feedback management in a procedure" },
        inputs: {
          STACK: {
            block: {
              type: "context_question",
              fields: {
                question_variable: { name: "question", type: "QUESTION" },
              },
              inputs: {
                statements: {
                  block: {
                    type: "controls_if",
                    inputs: {
                      IF0: {
                        block: {
                          type: "logic_negate",
                          inputs: {
                            BOOL: {
                              block: {
                                type: "is_solution_found",
                                fields: {
                                  solution_found_type:
                                    "isSolutionQuestionFound",
                                },
                              },
                            },
                          },
                        },
                      },
                      DO0: {
                        block: {
                          type: "display_element",
                          inputs: {
                            object: {
                              block: {
                                type: "text",
                                fields: { TEXT: "You did a mistake..." },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "context_question",
        fields: {
          question_variable: {
            name: "question",
            type: "QUESTION",
          },
        },
      },
      {
        kind: "block",
        type: "set_grade",
      },
      {
        kind: "block",
        type: "set_analytic",
        fields: {
          key: "",
        },
      },
    ],
  };
}
